module.exports = __webpack_public_path__ + "static/media/36-2.63d64d3c.mp3";